export default class EmrPatient {
    provides() {
        return {
            EmrRoutes: [() => require('./routes').default],
        };
    }
}
